var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { Component, Prop, Vue } from 'vue-property-decorator';
import LoaderCard from '@/components/loader-card/LoaderCard';
import { UserSubject } from '@/models/UserSubject';
import { addClass, removeClass } from '@/support/Html';
import ErrorHandler from '@/support/ErrorHandler';
import { User } from '@/models/User';
import { Group } from '@/models/Group';
import { AreaSubject } from '@/models/AreaSubject';
import { GroupSubject } from '@/models/GroupSubject';
import SelectFilter from '@/components/select-filter/SelectFilter';
import { generateUuid } from '@/support/String';
let RemoveLdpDialog = class RemoveLdpDialog extends Vue {
    constructor() {
        super(...arguments);
        this.isLoading = true;
        this.areaSubjects = [];
        this.isSelectedAllSubjects = false;
        this.selectedSubjects = [];
    }
    close() {
        this.$emit('input', false);
    }
    mounted() {
        this.initialize();
    }
    destroyed() {
        const body = document.querySelectorAll('body')[0];
        removeClass(body, 'bodyNoScroll');
    }
    async initialize() {
        this.isLoading = true;
        const body = document.querySelectorAll('body')[0];
        addClass(body, 'bodyNoScroll');
        await this.fetchSubjects();
        this.isLoading = false;
    }
    async fetchSubjects() {
        if (this.user && this.user.id) {
            try {
                const response = await new AreaSubject()
                    .user(this.user.id)
                    .all();
                this.areaSubjects = response.subjects;
                this.areaSubjects.forEach(areaSubject => {
                    if (areaSubject.groups) {
                        areaSubject.groups.map(group => {
                            group.id === generateUuid();
                        });
                    }
                    if (areaSubject.periods) {
                        areaSubject.periods.map(period => {
                            period.id === generateUuid();
                        });
                    }
                });
            }
            catch (error) {
                ErrorHandler.network(error);
            }
        }
        if (this.group && this.group.id) {
            try {
                const response = await new AreaSubject()
                    .group(this.group.id)
                    .all();
                this.areaSubjects = response.subjects;
                this.areaSubjects.forEach(areaSubject => {
                    if (areaSubject.groups) {
                        areaSubject.groups.map(group => {
                            group.id === generateUuid();
                        });
                    }
                    if (areaSubject.periods) {
                        areaSubject.periods.map(period => {
                            period.id === generateUuid();
                        });
                    }
                });
            }
            catch (error) {
                ErrorHandler.network(error);
            }
        }
    }
    async removePlp(subjectStatus) {
        let subjects = [];
        this.selectedSubjects.forEach(selectedSubject => {
            subjects = [...selectedSubject.value, ...subjects];
        });
        const payload = {
            subjects,
            filters: {
                statuses: subjectStatus === 'all' ? ['busy', 'highlighted', 'old'] : [subjectStatus],
            },
            attributes: {
                status: 'inactive',
            },
            select_all: this.isSelectedAllSubjects,
        };
        let id = '';
        if (this.user && this.user.id) {
            id = this.user.id;
            try {
                await new UserSubject().updateMass(id, payload);
                this.$store.dispatch('openDialog', this.dialogOptions);
                this.$emit('updated');
            }
            catch (error) {
                ErrorHandler.network(error);
            }
        }
        else if (this.group && this.group.id) {
            id = this.group.id;
            try {
                await new GroupSubject().updateMass(id, payload);
                this.$store.dispatch('openDialog', this.dialogOptions);
                this.$emit('updated');
            }
            catch (error) {
                ErrorHandler.network(error);
            }
        }
        else {
            return;
        }
    }
    get dialogOptions() {
        return {
            title: this.$t('dialogOptions.success').toString(),
            text: this.$tc('removeDialog.successMessage').toString(),
            type: 'success',
            buttons: {
                cancel: {
                    text: this.$t('Close').toString(),
                    action: () => {
                        this.close();
                    },
                },
            },
        };
    }
};
__decorate([
    Prop(),
    __metadata("design:type", typeof (_a = typeof User !== "undefined" && User) === "function" ? _a : Object)
], RemoveLdpDialog.prototype, "user", void 0);
__decorate([
    Prop(),
    __metadata("design:type", typeof (_b = typeof Group !== "undefined" && Group) === "function" ? _b : Object)
], RemoveLdpDialog.prototype, "group", void 0);
RemoveLdpDialog = __decorate([
    Component({
        components: {
            LoaderCard,
            SelectFilter
        },
    })
], RemoveLdpDialog);
export default RemoveLdpDialog;
